import Evented from "~/lib/evented";

export default class Hydrater extends Evented {

  post(d) {
    this.dispatchEvent(new CustomEvent("data", {detail: d}));
  }

  close() {
    this.dispatchEvent(new CustomEvent("end", {detail: true}));
  }

  get binded() {
    return !!this.listeners.has("data");
  }
}